<template>
  <div class="call-list-control">
    <BPaginationMetaText
      :current-page="currentPageModel"
      :paging-meta="meta"
    />
    <slot name="actions" />
    <BPagination
      v-model="currentPageModel"
      class="ml-a"
      :length="meta.totalPages"
      :total-visible="5"
    />
  </div>
</template>

<script setup lang="ts">
import { PaginationMeta } from '@/api/openapi';

defineProps<{
  meta: PaginationMeta;
}>();

const currentPageModel = defineModel<number>('currentPage');
</script>

<style lang="scss" scoped>
.call-list-control {
  display: flex;
  align-items: center;
  height: 100%;
  margin-inline: 32px;
  margin-bottom: 12px;
}
</style>
